import { API_URL } from '../../../app-config/constants';
import { CalendarDto } from '../../../types/CalendarDto';
import { get, post, remove } from '../request';

getByUserId.operation = 'READ';
export function getByUserId(userId: String) {
    return get<CalendarDto>(`${API_URL}/users/` + userId + '/calendars');
}

getForCurrentUser.operation = 'READ';
export function getForCurrentUser() {
    return get<CalendarDto>(`${API_URL}/user-calendar`);
}

deleteCalendar.operation = 'DELETE';
deleteCalendar.invalidates = ['getForCurrentUser'];
export function deleteCalendar(calendarId: String) {
    return remove<void>(`${API_URL}/calendars/${calendarId}`);
}

create.operation = 'CREATE';
export function create() {
    const postData = { name: 'Small Improvements' };
    return post<CalendarDto>(`${API_URL}/calendars`, { postData });
}
